export default function CtaSection() {
  return (
    <section className="relative py-20 md:py-28 px-4 md:px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=An%20elevated%20perspective%20of%20a%20carefully%20styled%20product%20display%20featuring%20a%20pair%20of%20designer%20sneakers%20a%20structured%20handbag%20and%20neatly%20folded%20clothing%20items%20arranged%20on%20a%20warm%20sandy%20beige%20surface%20with%20subtle%20coral%20colored%20fabric%20accents%20soft%20natural%20top%20lighting%20creating%20gentle%20shadows%20minimalist%20editorial%20product%20photography%20with%20clean%20and%20harmonious%20composition&width=1600&height=600&seq=cta-v2-bg-section&orientation=landscape"
          alt="AllChinaBuy Spreadsheet product collection"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/60 via-background-50/30 to-background-50/90"></div>

      <div className="relative z-10 max-w-7xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 mb-4 leading-tight">
          Explore the Latest<br />AllChinaBuy Spreadsheet
        </h2>
        <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto mb-8 leading-relaxed">
          Find trusted products, compare sellers, and discover the <strong>best allchinabuy spreadsheet</strong> options today. Start shopping smarter with verified links and trusted recommendations.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-primary-500 text-background-50 dark:text-foreground-950 font-medium rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 text-sm"
          >
            allchinabuy sheet
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-foreground-900 text-background-50 font-medium rounded-full hover:bg-foreground-950 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 text-sm"
          >
            buy it now
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shopping-bag-line text-sm"></i>
            </span>
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
          {['Trusted by Thousands', 'Verified Sellers', 'Updated Regularly', 'Free to Use'].map((tag) => (
            <span key={tag} className="text-xs text-foreground-500 flex items-center gap-1.5">
              <span className="w-1 h-1 rounded-full bg-primary-500"></span>
              {tag}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}